<template>
  <form novalidate>
    <h4 class="h4">Documentación fotográfica</h4>

    <div class="checkbox checkbox--azul">
      <input
      :disabled="!editando"
      type="checkbox"
      v-model="form.sinAdjuntos"
      id="no--adjuntos">
      <label class="form__label" for="no--adjuntos">No adjuntar nada</label>
    </div>

    <div v-if="form.sinAdjuntos">
      <form-group :error="errors.has('razon-no-adjuntos') && submitted">
        <textarea
        data-vv-validate-on="blur"
        :disabled="!editando"
        class="form__input"
        name="razon-no-adjuntos"
        v-validate="'required'"
        required
        v-model="form.razonSinAdjuntos"/>
        <label class="form__label">Justifique por qué no va a adjuntar nada</label>
      </form-group>
    </div>

    <div class="form__group" v-if="form.body.verHuellasDepredador && !form.sinAdjuntos">
      <label class="form__label form__label--required">
        Registro fotográfico
      </label>
      <button type="button"
      class="boton boton--adjuntar boton--s"
      @click="$refs.registroFotografico.click()"
      :disabled="!editando || form.registroFotografico.length === 2"/>
      <input
        class="no-display"
        ref="registroFotografico"
        type="file"
        accept="image/*"
        @change="leerArchivo('registroFotografico')">
      <br>
      <div v-if="!mostrarNoConexion && !cargandoImgs">
        <div  class="thumbnail" v-for="(foto, i) in form.registroFotografico" :key="i">
          <i v-if="editando" class="fas fa-trash text--extra-big text--rosado borrar-foto"
          @click="form.registroFotografico.splice(i, 1)"/>
          <img :src="foto.img">
          <input class="form__input" placeholder="Comentario..." v-model="foto.comentario"
          :disabled="!editando">
        </div>
      </div>
      <div v-if="cargandoImgs" class="text--center mt-8">
        <i class="fa fa-spinner fa-spin fa-3x"/>
        <p class="text">Cargando fotos...</p>
      </div>
      <p v-if="mostrarNoConexion" class="text mt-4">
        <i class="fas fa-fw fa-exclamation-triangle text--rojo mr-2"/>
        <span>No hay conexión a internet para cargar este contenido</span>
      </p>
    </div>

    <div class="form__group" v-if="!form.sinAdjuntos">
      <label class="form__label form__label--required">
        Fotografías del paisaje característico de la propiedad, tomada durante la visita
      </label>
      <button type="button"
      class="boton boton--adjuntar boton--s"
      @click="$refs.fotosPaisajeFinca.click()"
      :disabled="!editando || form.fotosPaisajeFinca.length === 2"/>
      <input
        class="no-display"
        ref="fotosPaisajeFinca"
        type="file"
        accept="image/*"
        @change="leerArchivo('fotosPaisajeFinca')">
      <br>
      <div v-if="!mostrarNoConexion && !cargandoImgs">
        <div class="thumbnail" v-for="(foto, i) in form.fotosPaisajeFinca" :key="i">
          <i v-if="editando" class="fas fa-trash text--extra-big text--rosado borrar-foto"
          @click="form.fotosPaisajeFinca.splice(i, 1)"/>
          <img :src="foto.img">
          <input class="form__input" placeholder="Comentario..." v-model="foto.comentario"
          :disabled="!editando">
        </div>
      </div>
      <div v-if="cargandoImgs" class="text--center mt-8">
        <i class="fa fa-spinner fa-spin fa-3x"/>
        <p class="text">Cargando fotos...</p>
      </div>
      <p v-if="mostrarNoConexion" class="text mt-4">
        <i class="fas fa-fw fa-exclamation-triangle text--rojo mr-2"/>
        <span>No hay conexión a internet para cargar este contenido</span>
      </p>
    </div>

    <div class="form__group" v-if="!form.sinAdjuntos">
      <label class="form__label form__label--required">
        Fotografías del animal comido, características del ataque o huellas
        tomadas durante la visita a la propiedad (poner la mínima evidencia)
      </label>
      <button type="button"
      class="boton boton--adjuntar boton--s"
      @click="$refs.fotosAnimalComido.click()"
      :disabled="!editando || form.fotosAnimalComido.length === 2"/>
      <input
        class="no-display"
        ref="fotosAnimalComido"
        type="file"
        accept="image/*"
        @change="leerArchivo('fotosAnimalComido')">
      <br>
      <div v-if="!mostrarNoConexion && !cargandoImgs">
        <div class="thumbnail" v-for="(foto, i) in form.fotosAnimalComido" :key="i">
          <i v-if="editando" class="fas fa-trash text--extra-big text--rosado borrar-foto"
          @click="form.fotosAnimalComido.splice(i, 1)"/>
          <img :src="foto.img">
          <input class="form__input" v-model="foto.comentario" placeholder="Comentario..."
          :disabled="!editando">
        </div>
      </div>
      <div v-if="cargandoImgs" class="text--center mt-8">
        <i class="fa fa-spinner fa-spin fa-3x"/>
        <p class="text">Cargando fotos...</p>
      </div>
      <p v-if="mostrarNoConexion" class="text mt-4">
        <i class="fas fa-fw fa-exclamation-triangle text--rojo mr-2"/>
        <span>No hay conexión a internet para cargar este contenido</span>
      </p>
    </div>
  </form>
</template>

<script>
import D from "debug";
import cloneDeep from "lodash/cloneDeep";
import isString from "lodash/isString";
import swal from "sweetalert2";

const debug = D("ciris:documentacionFotografica");

export default {
  name: "FormFotos",
  data() {
    return {
      submitted: false,
      mostrarNoConexion: false,
      enviando: false,
      cargandoImgs: false,
    };
  },
  props: {
    form: Object,
    editando: Boolean,
  },
  methods: {
    enviar,
    leerArchivo,
    validar,
  },
  created,
};

function created() {
  if (this.form._id && isString(this.form.fotosPaisajeFinca[0])) {
    if (navigator.onLine) {
      const params = {
        registroFotografico: this.form.registroFotografico,
        fotosPaisajeFinca: this.form.fotosPaisajeFinca,
        fotosAnimalComido: this.form.fotosAnimalComido,
      };
      this.cargandoImgs = true;
      return this.$store
        .dispatch(this.$actions.getImgsForm, params)
        .then((resp) => {
          if (this.editando) {
            window.copiaFotos = cloneDeep(resp);
          }
          this.form.registroFotografico = resp.registroFotografico;
          this.form.fotosPaisajeFinca = resp.fotosPaisajeFinca;
          this.form.fotosAnimalComido = resp.fotosAnimalComido;
          return resp;
        })
        .finally(() => {
          this.cargandoImgs = false;
        });
    }
    this.mostrarNoConexion = true;
  }
  return null;
}

function getConsecutivo() {
  return swal.fire({
    title: "Consecutivo / # de oficio",
    inputPlaceholder: "Ingrese el valor del consecutivo  / # de oficio",
    input: "text",
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    inputValidator: val => !val && "Este campo no puede quedar vacío",
  }).then((ans) => {
    if (ans.dismiss) {
      throw new Error("Cancel");
    }
    return ans.value;
  });
}

function enviar(form, indiceBorrador) {
  this.submitted = true;
  if (form.sinAdjuntos) {
    return this.$validator.validate().then((valido) => {
      if (valido) {
        return enviarSinImgs.call(this, form, indiceBorrador);
      }
      return false;
    });
  }
  if (form.fotosPaisajeFinca.length && form.fotosAnimalComido.length) {
    return enviarConImgs.call(this, form, indiceBorrador);
  }
  return this.$toastr("error", "Faltan imágenes adjuntas en los campos requeridos", "Error");
}

function enviarConImgs(form, indiceBorrador) {
  const self = this;
  return getConsecutivo()
    .then((consecutivo) => {
      const subir = fotos => self.$store.dispatch(self.$actions.postImagen, fotos);
      const promsRF = subir(form.registroFotografico);
      const promsPF = subir(form.fotosPaisajeFinca);
      const promsAC = subir(form.fotosAnimalComido);
      self.enviando = true;
      self.$store.commit(this.$actions.showModal, {
        componentName: "cargandoModal",
        params: { grande: true },
      });
      form.consecutivo = consecutivo;
      return [promsRF, promsPF, promsAC];
    })
    .then(promesas => Promise.all(promesas))
    .then((resul) => {
      debug("Imagenes subidas", resul);
      const temp = cloneDeep(form);
      temp.registroFotografico = resul["0"].data;
      temp.fotosPaisajeFinca = resul["1"].data;
      temp.fotosAnimalComido = resul["2"].data;
      temp.tipoDepredador = form.body.tipoDepredador;
      temp.estado = "nuevo";
      return temp;
    })
    .then(formConImgs => self.$store.dispatch(self.$actions.guardarFormulario, {
      formulario: formConImgs,
      index: indiceBorrador,
    }))
    .then(() => {
      self.$toastr("success", "Formulario enviado exitosamente", "Éxito");
      return self.$router.push({ name: "formularios" });
    })
    .finally(() => {
      self.enviando = false;
      self.$store.commit(this.$actions.hideModal);
    });
}

function enviarSinImgs(form, index) {
  this.enviando = true;
  return getConsecutivo()
    .then((consecutivo) => {
      const temp = cloneDeep(form);
      // borra imagenes por si cargaron algo antes de darle "no adjuntar nada"
      temp.registroFotografico = [];
      temp.fotosPaisajeFinca = [];
      temp.fotosAnimalComido = [];
      temp.consecutivo = consecutivo;
      temp.tipoDepredador = form.body.tipoDepredador;
      temp.estado = "nuevo";
      return this.$store.dispatch(this.$actions.guardarFormulario, { formulario: temp, index });
    })
    .then(() => {
      this.$toastr("success", "Formulario enviado exitosamente", "Éxito");
      return this.$router.push({ name: "formularios" });
    })
    .finally(() => {
      this.enviando = false;
    });
}

function leerArchivo(modelo) {
  const self = this;
  const reader = new FileReader();
  reader.onload = (e) => {
    self.form[modelo].push({
      img: e.target.result,
      comentario: "",
    });
  };
  reader.readAsDataURL(self.$refs[modelo].files[0]);
}

function validar() {
  return this.$validator.validate();
}
</script>

<style lang="scss">
.thumbnail {
  padding: 5px;
  border: 1px solid #ddd;
  display: inline-block;
  position: relative;
  margin: 7px 0;
  width: 100%;
  i {
    position: absolute;
    right: 5px;
    top: 5px;
  }
  img {
    width: 100%;
  }
}
</style>

<style lang="scss">
.loading-container {
  align-items: center;
  flex-direction: column;
  display: flex;
  justify-content: center;
}

.borrar-foto{
  right: 10px !important;
  top: 10px !important;
}
</style>
